import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import proxy from './proxy'

class Service extends ServiceBase {
  getDetailOrder(params) {
    return this.getData(() => proxy.getDetailOrder(params))
  }
  downloadReport(params) {
    return this.getFileDownload(() => proxy.downloadReport(params))
  }

  postCancelOrder(params) {
    return this.getData(() => proxy.postCancelOrder(params), true)
  }
}

const service = new Service()
export default service
